var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.92 7.01C19.72 6.42 19.16 6 18.5 6H7.5C6.84 6 6.29 6.42 6.08 7.01L4 13V21C4 21.55 4.45 22 5 22H6C6.55 22 7 21.55 7 21V20H19V21C19 21.55 19.45 22 20 22H21C21.55 22 22 21.55 22 21V13L19.92 7.01ZM7.5 17C6.67 17 6 16.33 6 15.5C6 14.67 6.67 14 7.5 14C8.33 14 9 14.67 9 15.5C9 16.33 8.33 17 7.5 17ZM18.5 17C17.67 17 17 16.33 17 15.5C17 14.67 17.67 14 18.5 14C19.33 14 20 14.67 20 15.5C20 16.33 19.33 17 18.5 17ZM6 12L7.5 7.5H18.5L20 12H6Z",
    fill: "#9299A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C2.68629 0 0 2.68629 0 6H1.5C1.5 3.51472 3.51472 1.5 6 1.5V0ZM6 3C4.34315 3 3 4.34315 3 6H4.5C4.5 5.17157 5.17157 4.5 6 4.5V3Z",
    fill: "#9299A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassage);
export default __webpack_public_path__ + "static/media/passage.f9bd1403b573cadcd6b123d5dae87fb1.svg";
export { ForwardRef as ReactComponent };